import {faPlus} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Group} from '@mantine/core';
import {Link} from 'react-router-dom';
import {FieldsService} from '../api/generated/FieldsService';
import {BasicPage} from '../components/basic-page';
import {
  usePagedDataTable,
  PagedDataTableConfig,
  renderEditButton,
} from '../hooks/paged-data-table/use-paged-data-table';
import {ROUTES} from '../routes';

const RuntimeConfig = {
  renderActions: (
    <Button component={Link} to={ROUTES.ADMIN.FIELDS.CREATE.path}>
      <Group gap={'xs'}>
        <FontAwesomeIcon icon={faPlus} /> New Field
      </Group>
    </Button>
  ),
};

export const FieldListing = () => {
  const pagedDataTable = usePagedDataTable(FieldsService.getAll, TableConfig, {
    ...RuntimeConfig,
  });

  return <BasicPage title="Fields">{pagedDataTable}</BasicPage>;
};

const TableConfig = PagedDataTableConfig(FieldsService.getAll, {
  columns: [
    {
      accessor: '',
      title: '',
      render: (item) =>
        renderEditButton({
          item: {...item, id: Number(item.id)},
          descriptor: 'Field',
          route: ROUTES.ADMIN.FIELDS.DETAIL.path,
        }),
      width: 50,
    },
    {
      accessor: 'name',
      sortable: true,
    },
    {
      accessor: 'type',
      sortable: true,
    },
    {
      accessor: 'sortOrder',
      title: 'Sort Order',
      sortable: true,
    },
    {
      accessor: 'inactive',
      title: 'Status',
      render: (item) => (item.inactive ? 'Inactive' : 'Active'),
    },
  ],
  defaultSort: {
    column: 'sortOrder',
    direction: 'ASC',
  },
  searchFieldNames: ['name', 'type'],
});
